enum ContactTypes {
  Phone = 'Phone',
  Email = 'Email',
  Address = 'Address',
}

export default ContactTypes;
